import React from 'react'

const Endorsementpaymentapproval = () => {
  return (
    <div>
      paymentapprovalEndorsement
    </div>
  )
}

export default Endorsementpaymentapproval
